import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e00c63c0"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "ClickToCall Api", -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Endpoints", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode("REST POST een ClickToCall Json → "),
  /*#__PURE__*/_createElementVNode("a", { href: "https://mockservices.vijzelmolen.nl/api/ClickToCall/SendClickToCall" }, "https://mockservices.vijzelmolen.nl/api/ClickToCall/SendClickToCall")
], -1))
const _hoisted_4 = { class: "message" }
const _hoisted_5 = { class: "fields" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Gebruiker ID:", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Account ID:", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Gebruiker Telefoon:", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Relatie Voornaam:", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Relatie Achternaam:", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Relatie Telefoon:", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _hoisted_2,
    _hoisted_3,
    _createElementVNode("button", {
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.clearData && _ctx.clearData(...args)))
    }, "Clear"),
    _createElementVNode("ul", _hoisted_4, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.messages, (msg, index) => {
        return (_openBlock(), _createElementBlock("li", { key: index }, [
          _createElementVNode("ul", _hoisted_5, [
            _createElementVNode("li", null, [
              _hoisted_6,
              _createTextVNode(" " + _toDisplayString(msg.user_id), 1)
            ]),
            _createElementVNode("li", null, [
              _hoisted_7,
              _createTextVNode(" " + _toDisplayString(msg.account_id), 1)
            ]),
            _createElementVNode("li", null, [
              _hoisted_8,
              _createTextVNode(" " + _toDisplayString(msg.user_phone_number), 1)
            ]),
            _createElementVNode("li", null, [
              _hoisted_9,
              _createTextVNode(" " + _toDisplayString(msg.customer_first_name), 1)
            ]),
            _createElementVNode("li", null, [
              _hoisted_10,
              _createTextVNode(" " + _toDisplayString(msg.customer_last_name), 1)
            ]),
            _createElementVNode("li", null, [
              _hoisted_11,
              _createTextVNode(" " + _toDisplayString(msg.customer_phone_number), 1)
            ])
          ]),
          _hoisted_12
        ]))
      }), 128))
    ])
  ], 64))
}